<template>
  <div>
    <breadcrumb :items="breadcrumbs"></breadcrumb>
    <v-container fluid>
      <div class="d-flex mb-4">
        <h2>{{ $t("reports.productionReport") }}</h2>
      </div>
      <v-card elevation="0" class="px-5">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="3" class="px-1">
              <v-select
              :loading="countryLoading"
              :items="countries"
              item-text="name"
              item-value="id"
              dense
              outlined
              v-model="filterData.country"
              :placeholder="$t('reports.filterByCountry')"
              @change="getStates(filterData.country)"
            ></v-select>
            </v-col>
            <v-col cols="3" class="px-1">
              <v-select
              :loading="stateLoading"
              :items="regions"
              item-text="name"
              item-value="id"
              dense
              outlined
              v-model="filterData.region"
              :placeholder="$t('reports.filterByRegion')"
            ></v-select>
            </v-col>
            <v-col cols="3" class="px-1">
              <FarmDropdown 
                v-model="filterData.farm"
              /> 
            </v-col>
            <v-col cols="3" class="px-1">
              <v-select
              :items="breeds"
              dense
              outlined
              v-model="filterData.breed"
              :placeholder="$t('reports.filterByTrait')"
            ></v-select>
            </v-col>
            <!-- <v-select
              :items="regions"
              item-text="name"
              item-value="roleNumber"
              dense
              outlined
              class="shrink mr-2 wdt"
              v-model="region"
              :placeholder="$t('reports.filterByYear')"
            ></v-select> -->
          </v-row>
          <template>
            <div class="d-flex my-5" v-if="items.length > 0">
              <!-- <p class="mt-2 ml-4">Birth Info</p> -->
              <v-spacer></v-spacer>
              <div class="py-1 title">
                {{ from }} - {{ to }} of
                {{ totalProducts }}
              </div>
              <v-btn
                class="mx-2"
                fab
                small
                outlined
                color="primary"
                :disabled="productOptions.page <= 1"
                @click="pageChange(false)"
              >
                <v-icon dark> mdi-chevron-left </v-icon>
              </v-btn>
              <v-btn
                class="mx-2"
                fab
                small
                outlined
                color="primary"
                :disabled="productOptions.page >= totalPages"
                @click="pageChange(true)"
              >
                <v-icon dark> mdi-chevron-right </v-icon>
              </v-btn>
              <v-btn
                v-if="items.length > 0"
                class="mx-2"
                fab
                small
                outlined
                color="primary"
                @click="exportToPDF"
              >
                <v-icon dark> mdi-export </v-icon>
              </v-btn>
              <v-btn
                class="mx-2"
                fab
                small
                outlined
                color="primary"
                @click="
                  printPDF(
                    $refs.document,
                    'Production Report(Analytics and Reporting)'
                  )
                "
              >
                <v-icon dark> mdi-printer </v-icon>
              </v-btn>
            </div>
          </template>
          <div ref="document">
            <v-row v-if="items.length > 0">
              <v-col cols="12" v-for="(item, index) in items" :key="index">
                <v-card flat elevation="0" outlined>
                  <v-toolbar dense flat :elevation="0">
                    <v-toolbar-title class="text-capitalize">{{
                      item.name
                    }}</v-toolbar-title>
                    <v-spacer></v-spacer>

                    <v-btn icon>
                      <v-icon>mdi-magnify</v-icon>
                    </v-btn>
                  </v-toolbar>
                  <v-card-text class="pa-0">
                    <v-data-table
                      :headers="orderHeaders"
                      :items="newItems[index]"
                      :items-per-page="5"
                      hide-default-footer
                      :loading="loading"
                      loading-text="Loading Health Data..."
                      :options.sync="orderOptions"
                      :server-items-length="totalOrders"
                    >
                      <template v-slot:footer></template>
                      <template v-slot:progress>
                        <v-progress-linear
                          color="primary"
                          :height="6"
                          indeterminate
                        ></v-progress-linear>
                      </template>
                    </v-data-table>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>

            <!-- <v-card flat elevation="0" outlined class="mt-5">
            <v-toolbar dense flat :elevation="0">
              <v-toolbar-title>Production of Whole Milk</v-toolbar-title>
              <v-spacer></v-spacer>

              <v-btn icon>
                <v-icon>mdi-magnify</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text class="pa-0">
              <v-data-table
                :headers="orderHeaders"
                :items="orderData"
                :items-per-page="5"
                :hide-default-footer="true"
                :loading="loading"
                loading-text="Loading Health Data..."
                :options.sync="orderOptions"
                :server-items-length="totalOrders"
              >
                <template v-slot:footer></template>
              </v-data-table>
            </v-card-text>
          </v-card> -->
            <v-card v-else class="px-5 mt-5">
              <v-card-text class="text-center">
                <v-avatar size="135"> </v-avatar>
                <p class="text-h4 font-weight-bold">{{ $t("noRecordFound") }}</p>
                <p>{{ $t("reportings.dataNotAvailable") }}</p>
              </v-card-text>
            </v-card>
          </div>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>
<script>
import FarmService from "@/_services/farmService.js";
import ProductService from "@/_services/ReportingService.js";
import loadingMixin from "@/mixins/LoadingMixin";
import html2pdf from "html2pdf.js";
import printJS from "print-js";
import { breeds } from "@/models/units.js";
import FarmDropdown from "@/components/FarmDropdown.vue";

export default {
  components: {
    FarmDropdown
  },
  mounted() {
    this.getCountries()
    document.title = this.$t('reports.analyticsAndReporting');
    // this.searchFarm(this.farm);
    // this.getProductByCat();
  },
  watch: {
    async farmSearch(val) {
      await this.searchFarm(val);
    },
    filterData: {
      handler() {
        this.getProductByCat();
      },
      deep:true
    },
  },
  data() {
    return {
      countryLoading: false,
      stateLoading: false,
      breeds,
      filterData:{
        country: null,
        region: null,
        farm: null,
        breed: null,
      },
      loading: false,
      countries: [],
      regions: [],
      farmsList: [],
      items: [],
      newItems: [],
      countary: null,
      region: null,
      farmLoading: false,
      farmSearch: "",
      search: "",
      farm: { farmNumber: "FRM000011018186" },
      totalOrders: 10,
      productOptions: {
        page: 1,
        limit: 5,
      },
      orderOptions: {
        page: 1,
        limit: 5,
      },
      orderHeaders: [
        {
          text: this.$t('farm.productName'),
          value: "productName",
          align: "start",
          sortable: false,
        },
        {
          text: this.$t('organizationNtrInfo.recepientName'),
          value: "recipientName",
          align: "start",
          sortable: false,
        },
        {
          text: this.$t('organizationNtrInfo.orderID'),
          align: "start",
          value: "orderNumber",
          sortable: false,
        },
        {
          text: this.$t('organizationNtrInfo.recipientID'),
          value: "recipientId",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t('organizationNtrInfo.transactionID'),
          value: "transactionId",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t('organizationNtrInfo.quantity'),
          value: "productQty",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t('organizationNtrInfo.cost'),
          value: "totalPrice",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t('date'),
          value: "transactionDateTransformed",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t('status'),
          value: "status",
          align: "right",
          sortable: false,
        },
      ],
      orderData: [
        {
          transactionId: "TXT323242111",
          date: " 02/02/2021",
          productName: "Standard Milk",
          productQty: " 20 gallons",
          recipientId: " RCPID4899589566",
          recipientName: " hemant",
          recipientType: " food corp",
          totalPrice: " 1",
          status: "pending",
          orderNumber: "ONUM000002969763",
        },
        {
          transactionId: "TXT323242111",
          date: " 02/02/2021",
          productName: "Standard Milk",
          productQty: " 20 gallons",
          recipientId: " RCPID4899589566",
          recipientName: " hemant",
          recipientType: " food corp",
          totalPrice: " 1",
          status: "pending",
          orderNumber: "ONUM000002969763",
        },
        {
          transactionId: "TXT323242111",
          date: " 02/02/2021",
          productName: "Standard Milk",
          productQty: " 20 gallons",
          recipientId: " RCPID4899589566",
          recipientName: " hemant",
          recipientType: " food corp",
          totalPrice: " 1",
          status: "pending",
          orderNumber: "ONUM000002969763",
        },
        {
          transactionId: "TXT323242111",
          date: " 02/02/2021",
          productName: "Standard Milk",
          productQty: " 20 gallons",
          recipientId: " RCPID4899589566",
          recipientName: " hemant",
          recipientType: " food corp",
          totalPrice: " 1",
          status: "pending",
          orderNumber: "ONUM000002969763",
        },
        {
          transactionId: "TXT323242111",
          date: " 02/02/2021",
          productName: "Standard Milk",
          productQty: " 20 gallons",
          recipientId: " RCPID4899589566",
          recipientName: " hemant",
          recipientType: " food corp",
          totalPrice: " 1",
          status: "pending",
          orderNumber: "ONUM000002969763",
        },
        {
          transactionId: "TXT323242111",
          date: " 02/02/2021",
          productName: "Standard Milk",
          productQty: " 20 gallons",
          recipientId: " RCPID4899589566",
          recipientName: " hemant",
          recipientType: " food corp",
          totalPrice: " 1",
          status: "pending",
          orderNumber: "ONUM000002969763",
        },
      ],
      from: 0,
      to: 0,
      totalProducts: 1,
      totalPages: 1,
      breadcrumbs: [
        {
          text: this.$t('dashboard'),
          disabled: false,
          to: "/",
        },
        {
          text: this.$t('reports.analyticsAndReporting'),
          disabled: true,
        },
        {
          text: this.$t('reports.productionReport'),
          disabled: true,
        },
      ],
    }
  },
  methods: {
    getCountries() {
      this.countryLoading=true
      FarmService.loadCountries().then((data) => {
        this.countries = data.data;
        this.countryLoading=false
      });
    },
    
    getStates(id) {
      this.stateLoading=true
      if(!id) return 
      FarmService.loadStates(id).then((data) => {
        this.regions = data.data.length!==0 ? data.data:{id:"0",name:"No state available"};
        this.stateLoading=false
      });
    },

    async printPDF(reference, title) {
      let opt = {
        margin: 1,
        filename: `${title}.pdf`,
        image: { type: "jpeg", quality: 0.95 },
        html2canvas: { scale: 2, useCORS: true },
        jsPDF: { unit: "in", format: "a4", orientation: "landscape" },
      };

      let worker = await html2pdf()
        .set(opt)
        .from(reference)
        .toCanvas()
        .outputPdf("blob", `${title}.pdf`);
      let file = new File([worker], `${title}.pdf`, {
        type: "application/pdf",
      });
      var pdfUrl = await URL.createObjectURL(file);
      await printJS({ printable: `${pdfUrl}`, type: "pdf", showModal: true });
    },

    searchFarm(val) {
      if (val == "" || val == null) return;
      this.farmsLoading = true;
      FarmService.searchFarms(val)
        .then((res) => {
          console.log(res);
          this.farmsList = res.data.farms;
        })
        .catch((err) => {
          console.log(err);
          // this.users = [];
        })
        .finally(() => (this.farmsLoading = false));
    },
    // async changedLabel(event) {
    //   this.categories = event;
    //   await this.getProductByCat()
    // },
    exportToPDF() {
      html2pdf(this.$refs.document, {
        margin: 1,
        filename: "productionReport.pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { dpi: 200, letterRendering: true },
        jsPDF: {
          unit: "in",
          format: "letter",
          orientation: "landscape",
          compress: false,
        },
      });
    },
    getProductByCat() {
      // this.startLoading();
      ProductService.getAllProducts(
        this.productOptions,
        this.filterData
      ).then(async (res) => {
        console.log("hello", res);
        this.items = res.data.products.rows;
        this.totalProducts = res.data.products.total_rows;
        this.pageCount = Math.ceil(
          this.totalProducts / this.productOptions.limit
        );
        this.totalPages = Math.ceil(
          this.totalProducts / this.productOptions.limit
        );
        this.from =
          (this.productOptions.page - 1) * this.productOptions.limit + 1;
        this.to =
          this.productOptions.page * this.productOptions.limit -
          (this.productOptions.limit - res.data.products.num_rows);
        if (this.newItems.length) {
          this.newItems.length = 0;
        }
        for (var i = 0; i < this.items.length; i++) {
          this.loading = true;
          // console.log("index", i, this.items[i].productNumber);
          await ProductService.getProductsOrder(
            this.items[i].productNumber
          ).then((res) => {
            console.log(res);
            // this.newItems[i]=res.data.productionReport.rows;
            this.newItems.push(res.data.OrderListByProduct.rows);
            console.log(this.newItems);
            this.loading = false;
          });
        }
        // this.stopLoading();
      });
    },
    pageChange(t) {
      if (t) this.productOptions.page = this.productOptions.page + 1;
      else this.productOptions.page = this.productOptions.page - 1;

      this.getProductByCat();
    },
  },
  mixins: [loadingMixin],
};
</script>
<style lang="scss" scoped>
::v-deep .wdt {
  width: 175px;
}
::v-deep .v-data-table-header {
  background: $secondary2-color;
}
::v-deep .v-data-table-header span {
  text-transform: uppercase !important;
  color: black;
}
</style>